import { render, staticRenderFns } from "./AiReportPayment.vue?vue&type=template&id=b66c5064&scoped=true"
import script from "./AiReportPayment.vue?vue&type=script&lang=js"
export * from "./AiReportPayment.vue?vue&type=script&lang=js"
import style0 from "./AiReportPayment.vue?vue&type=style&index=0&id=b66c5064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66c5064",
  null
  
)

export default component.exports